import React from "react";
import PropTypes from "prop-types";

const ValidationError = props => {
  const { className, children } = props;

  let items;
  if (children === null) {
    items = [];
  } else if (Array.isArray(children)) {
    items = children;
  } else {
    items = [children];
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <ul className={`validation-error ${className}`}>
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};

ValidationError.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default ValidationError;
